export default __webpack_public_path__ + "static/media/check.932a2ad5.svg";